import React from 'react'

import { SavedFilterCol, QuickFilterCol, PresetFilterContainer, NoSavedFilters } from './PresetFilters.styles'

import QuickFilterContainer from './QuickFilter.container'
import SavedFilterContainer from './SavedFilter.container'

import Typestack from '../../../typestack'

const PresetFiltersComponent = ({ quickFilters, savedFilters, events, i18n, applied, analytics }) => {
  return (
    <PresetFilterContainer data-testid='preset-filter-container'>
      {quickFilters && quickFilters.length > 0 &&
        <QuickFilterCol data-testid='quick-filters-col'>
          <div style={{ 'marginBottom': '30px' }}>
            <Typestack type='eyebrow' style={{ color: '#4d4d4d' }}>{i18n.quickFilters}</Typestack>
          </div>

          {quickFilters && quickFilters.map((quickFilter, i) => {
            return (
              <QuickFilterContainer
                analytics={analytics}
                key={'quick-filter-' + i}
                applied={applied}
                handleApply={events.handleQuickFilterApply}
                {...quickFilter}
              />
            )
          })}

        </QuickFilterCol>
      }

      {savedFilters && savedFilters.enabled && savedFilters.endpoint &&
        <SavedFilterCol data-testid='saved-filters-col'>
          <div style={{ 'marginBottom': '30px' }}>
            <Typestack type='eyebrow' style={{ color: '#4d4d4d' }}>{i18n.savedFilters}</Typestack>
          </div>

          {savedFilters.filters && savedFilters.filters.map((savedFilter, i) => {
            return (
              <SavedFilterContainer
                analytics={analytics}
                key={'saved-filter-' + i}
                i18n={i18n}
                applied={applied}
                handleApply={events.handleSavedFilterApply}
                handleRemove={events.handleSavedFilterRemove}
                {...savedFilter}
              />
            )
          })}

          {savedFilters.filters && savedFilters.filters.length < 1 &&
            <NoSavedFilters>{i18n.noSavedFilters}</NoSavedFilters>
          }
        </SavedFilterCol>
      }

    </PresetFilterContainer>
  )
}

export default PresetFiltersComponent
